import Vue from 'vue';
import Vuex from 'vuex';

import accounts from './modules/accounts';
import agentBots from './modules/agentBots';
import agents from './modules/agents';
import internalChat from './modules/internalChat'; // feat/chat_interno_pulido
import articles from './modules/helpCenterArticles';
import attributes from './modules/attributes';
import auth from './modules/auth';
import auditlogs from './modules/auditlogs';
import automations from './modules/automations';
import bulkActions from './modules/bulkActions';
import campaigns from './modules/campaigns';
import cannedResponse from './modules/cannedResponse';
import categories from './modules/helpCenterCategories';
import contactConversations from './modules/contactConversations';
import contactLabels from './modules/contactLabels';
import contactNotes from './modules/contactNotes';
import contacts from './modules/contacts';
import conversationLabels from './modules/conversationLabels';
import conversationMetadata from './modules/conversationMetadata';
import conversationPage from './modules/conversationPage';
import conversations from './modules/conversations';
import conversationSearch from './modules/conversationSearch';
import conversationStats from './modules/conversationStats';
import conversationTypingStatus from './modules/conversationTypingStatus';
import conversationWatchers from './modules/conversationWatchers';
import csat from './modules/csat';
import customViews from './modules/customViews';
import customRole from './modules/customRole';
import dashboardApps from './modules/dashboardApps';
import globalConfig from 'shared/store/globalConfig';
import inboxAssignableAgents from './modules/inboxAssignableAgents';
import inboxes from './modules/inboxes';
import inboxMembers from './modules/inboxMembers';
import integrations from './modules/integrations';
import labels from './modules/labels';
import macros from './modules/macros';
import notifications from './modules/notifications';
import portals from './modules/helpCenterPortals';
import reports from './modules/reports';
import sla from './modules/sla';
import teamMembers from './modules/teamMembers';
import teams from './modules/teams';
import userNotificationSettings from './modules/userNotificationSettings';
import webhooks from './modules/webhooks';
import draftMessages from './modules/draftMessages';
import SLAReports from './modules/SLAReports';
import CaseReports from './modules/CaseReports'; // proyecto@metricas_casos
import webphone from './modules/webphone';

import scheduledMessages from './modules/scheduledMessages';
// KANBAN0725
import kanbanTypeProcesses from './modules/kanbanTypeProcesses';
import kanbanProcesses from './modules/kanbanProcesses';
import kanbanConversations from './modules/kanbanConversations';
// KANBAN0725
// ============================================================
// proyecto@contact_tracking
// /home/chatwoot/chatwoot/app/javascript/dashboard/store/index.js
import contactTrackings from './modules/contactTrackings';
// ===========================================================

// proyecto@tracking_templates
import trackingTemplates from './modules/trackingTemplates';
import whatsappCalls from './modules/whatsappCalls'; // diag/llamadas_whatsapp
// proyecto@automatizacion_campanas
import trackingCampaignOptions from './modules/trackingCampaignOptions';
// @tickets_cases
import caseTickets from './modules/caseTickets';
// @query_databases
import externalDb from './modules/externalDb';
// @waba_templates
import whatsappTemplates from './modules/whatsappTemplates';
// proyecto@google_calendar
import googleCalendar from './modules/googleCalendar';

const plugins = [];

Vue.use(Vuex);
export default new Vuex.Store({
  modules: {
    accounts,
    agentBots,
    agents,
    internalChat,
    articles,
    attributes,
    auth,
    automations,
    auditlogs,
    bulkActions,
    campaigns,
    cannedResponse,
    categories,
    contactConversations,
    contactLabels,
    contactNotes,
    contacts,
    conversationLabels,
    conversationMetadata,
    conversationPage,
    conversations,
    conversationSearch,
    conversationStats,
    conversationTypingStatus,
    conversationWatchers,
    csat,
    customViews,
    customRole,
    dashboardApps,
    globalConfig,
    inboxAssignableAgents,
    inboxes,
    inboxMembers,
    integrations,
    labels,
    macros,
    notifications,
    portals,
    reports,
    teamMembers,
    teams,
    userNotificationSettings,
    webhooks,
    draftMessages,
    sla,
    slaReports: SLAReports,
    webphone,
    scheduledMessages,
    // KANBAN0725
    kanbanTypeProcesses,
    kanbanProcesses,
    kanbanConversations,
    // KANBAN0725
    contactTrackings, // proyecto@contact_tracking
    trackingTemplates, // proyecto@tracking_templates
    whatsappCalls, // diag/llamadas_whatsapp
    trackingCampaignOptions, // proyecto@automatizacion_campanas
    googleCalendar, // proyecto@google_calendar
    caseTickets, // @tickets_cases
    caseReports: CaseReports, // proyecto@metricas_casos
    externalDb, // @query_databases
    whatsappTemplates, // @waba_templates
  },
  plugins,
});
